import { PassStatus, UserProfile } from "@/__generated__/graphql";
import { useAppContext } from "@/modules/app";
import { intersection, map, partition } from "lodash";
import { useState } from "react";
import HomeView from "../views/HomeView";

export default function Home({ user }: { user: UserProfile }) {
  const { allUpcomingLessons, allPasses, clubMembership } = useAppContext();
  const [showAllLessons, setShowAllLessons] = useState(false);

  const allFilteredLessons = allUpcomingLessons.filter(
    (lesson) =>
      intersection(map(allPasses, "recId"), [...lesson.bookingsRecIds, ...lesson.waitingListRecIds]).length > 0
  );

  const lessons = showAllLessons ? allFilteredLessons : allFilteredLessons.slice(0, 2);

  const [futurePasses, pastPasses] = partition(
    allPasses,
    (pass) => pass.status === PassStatus.Active || pass.status === PassStatus.NotActive
  );

  const passes = futurePasses.length > 0 ? futurePasses : pastPasses.slice(0, 1);

  return (
    <HomeView
      user={user}
      lessons={lessons}
      passes={passes}
      clubMembership={clubMembership}
      allLessons={allFilteredLessons}
      showAllLessons={showAllLessons}
      onToggleShowAll={() => setShowAllLessons(!showAllLessons)}
    />
  );
}
